import { FC, useEffect, useState } from 'react'
import { CSSTransition } from 'react-transition-group'

import { Button } from 'components/Forms'
import { t } from 'translations'

type Props = {
  message?: string
  type?: 'fades' | 'eases' | 'slides'
  children: React.ReactNode
}

const FadeInOut: FC<Props> = ({ children, message, type = 'fades' }) => {
  const [showButton, setShowButton] = useState(true)
  const [showMessage, setShowMessage] = useState(false)

  useEffect(() => {
    // If no message is passed, we display the child right after mounting
    if (!message) setShowMessage(true)
  }, [message, setShowMessage])

  return (
    <>
      {/* Button to toggle the animated children */}
      {showButton && message ? (
        <Button onClick={() => setShowMessage(true)} size="lg">
          {t(message)}
        </Button>
      ) : null}

      <CSSTransition classNames={type} timeout={800} in={showMessage} unmountOnExit onEnter={() => setShowButton(false)} onExited={() => setShowButton(true)}>
        {children}
      </CSSTransition>
    </>
  )
}

export default FadeInOut
